'use client';
import { BlockReference } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';
import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { BlogAuthor } from './BlogAuthor';

export interface AuthorItemStrapiProps {
  title: string;
  image: ImageStrapiProps;
  name: string;
  bio: RichTextFieldStrapiProps;
  authorPageSlug?: string;
}

export interface AuthorStrapiProps {
  blogAuthor: Required<BlockReference<AuthorItemStrapiProps>>;
}

export function AuthorStrapi({
  block,
}: BlockComponentModel<AuthorStrapiProps>) {
  return (
    <BlockWrapper data-tracker-section={SECTION_NAMES.AUTHOR}>
      <BlogAuthor block={block} />
    </BlockWrapper>
  );
}
